import { signal } from '@preact/signals-react'

export const roleSignal = signal({})
export const roleLoadedSignal = signal(false)
export const roleErrorSignal = signal(null)

export const organizationRoleListSignal = signal([])
export const organizationRoleListLoadedSignal = signal(false)
export const organizationRoleListErrorSignal = signal(null)
export const organizationRoleDictionarySignal = signal({})

export const rolePermissionsSignal = signal([])
export const rolePermissionsLoadedSignal = signal(false)
export const rolePermissionsErrorSignal = signal(null)

export const ephemeralRoleSignal = signal(null)
export const ephemeralRoleLoadedSignal = signal(false)
export const ephemeralRoleErrorSignal = signal(null)

export const roleBusinessEntitiesSignal = signal([])
export const roleBusinessEntitiesLoadedSignal = signal(false)
export const roleBusinessEntitiesErrorSignal = signal(null)

export const canGrantRoleListSignal = signal([])
export const canGrantRoleListLoadedSignal = signal(false)
export const canGrantRoleListErrorSignal = signal(null)

export const roleDictionarySignal = signal(null)